export enum Secretary {
  extension = "extension",
  graduados = "graduados"
}

export const SecretaryEnumValues = [Secretary.extension, Secretary.graduados];

export enum SeparateApprovalStatusAttributes {
  extension = "extensionApprovalStatus",
  graduados = "graduadosApprovalStatus"
}
